import React, { useState } from "react";
import Select from "react-select";

import { useSelectStyles } from "../../hooks/useSelectStyles";
import { Link } from "react-router-dom";
import NotFreeModal from "./NotFreeModal";
const invoiceData = {
  document_name: "doc02234020250410221448.pdf",
  type: "Bank Transfer Confirmation and Invoice/Receipt",
  bank_transfer_details: {
    request_received_date: "26/03/25 13:43",
    sender: 'מ.ח הנדסת מדידות (מסארוה חוסאם) בע"מ',
    sender_account: "665-406592",
    sender_bank: "בנק הפועלים, 665 טייבה",
    amount: "3,304.00 ₪",
    recipient: "ג'בארה אחמד",
    recipient_account: "9269012,951",
    recipient_bank: "בנק לאומי, טייבה",
    transfer_execution_date: "26/03/25",
    reference_number: "387502402",
    transfer_details: "עבור שירות חודש 3",
    total_fees: "11.68 ILS שקל חדש",
  },
  invoice_receipt_details: {
    document_type: "חשבונית מס קבלה",
    date: "27/03/25",
    time: "14:59",
    invoice_number: "02/050899",
    customer_number: "00002",
    supplier: "ג'בארה אחמד רואה חשבון",
    supplier_address: "טייבה משולש טייבה 40400",
    supplier_phone: "0524508089",
    supplier_fax: "09-7733456",
    supplier_authorized_dealer_number: "29945573",
    recipient_name: 'מ.ח הנדסת מדידות מ.חוסאם בע"מ',
    recipient_address: "טייבה משולש, מיקוד 40400",
    items: [
      {
        item_number: "01",
        description: "שכר טרחה",
        quantity: "1.00",
        unit_price_ils: "2,800.00",
        total_ils: "2,800.00",
      },
    ],
    total_before_vat: "2,800.00",
    discount_percentage: "00%",
    discount_amount: "0.00",
    total_after_discount: "2,800.00",
    vat_percentage: "18.00%",
    vat_amount: "504.00",
    total_due: "3,304.00",
    payment_details: [
      {
        line_details: "קבלה מחשבונית העברה בנקאית",
        payment_type: "העברה בנקאית",
        payment_date: "27/03/25",
        amount_ils: "3,304.00",
      },
    ],
  },
};
const EditInvoiceModal = () => {
  const styles = useSelectStyles();

  const bankOptions = [
    { label: "בנק הפועלים, 665 טייבה", value: "בנק הפועלים, 665 טייבה" },
    { label: "בנק לאומי, טייבה", value: "בנק לאומי, טייבה" },
  ];

  const docTypeOptions = [
    { label: "חשבונית מס קבלה", value: "חשבונית מס קבלה" },
    { label: "חשבונית מס", value: "חשבונית מס" },
  ];

  const paymentTypeOptions = [
    { label: "העברה בנקאית", value: "העברה בנקאית" },
    { label: "מזומן", value: "מזומן" },
    { label: "צ'ק", value: "צ'ק" },
  ];

  const vatOptions = [
    { label: "17%", value: "17%" },
    { label: "18%", value: "18%" },
    { label: "0%", value: "0%" },
  ];

  const handleSelectChange = (key, selectedOption, section) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: selectedOption.value,
      },
    }));
  };
  const [formData, setFormData] = useState(invoiceData);
  return (
    <>
      <div id="edit-invoice" className="modal custom-modal fade" role="dialog">
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-primary">تعديل مفصل </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body dark">
              <form className=" p-4">
                {/* Document Name */}

                <div className=" card  mt-4">
                  <div className="card-header">
                    <h3 className="   col-auto float-end ms-auto mb-0 ">
                      <Link
                        to="#"
                        className="btn add-btn "
                        data-bs-toggle="modal"
                        data-bs-target="#notFreeModal"
                      >
                        <i className="fa fa-eye" />
                        اظهار المستند
                      </Link>
                    </h3>
                  </div>
                  <div className="card-body row">
                    <div className="col-md-3">
                      <div className=" input-block mb-3 mt-2">
                        <label className="form-label text-primary">
                          Document Name
                        </label>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <div className=" input-block mb-3">
                        <input
                          className="form-control"
                          type="text"
                          value={invoiceData.document_name}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bank Transfer Details */}
                <div className="card">
                  <div className="card-header">
                    <h3 className="text-primary card-title mb-0 mt-3">
                      Bank Transfer Details
                    </h3>
                  </div>

                  <div className="row card-body">
                    {Object.entries(invoiceData.bank_transfer_details).map(
                      ([key, value]) => (
                        <div className="col-md-6" key={key}>
                          <div className="input-block mb-3">
                            <label className="col-form-label">
                              {key
                                .replace(/_/g, " ")
                                .replace(/\b\w/g, (l) => l.toUpperCase())}
                            </label>
                            {key === "sender_bank" ||
                            key === "recipient_bank" ? (
                              <Select
                                value={{ label: value, value }}
                                onChange={(selected) =>
                                  handleSelectChange(
                                    key,
                                    selected,
                                    "bank_transfer_details"
                                  )
                                }
                                options={bankOptions}
                                styles={styles}
                              />
                            ) : (
                              <input
                                className="form-control"
                                type="text"
                                value={value}
                                readOnly
                              />
                            )}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>

                {/* Invoice Receipt Details */}
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title text-primary mb-0 mt-3 ">
                      Invoice Receipt Details
                    </h3>
                  </div>
                  <div className="row card-body p-4 justify-content-start">
                    {Object.entries(invoiceData.invoice_receipt_details).map(
                      ([key, value]) => {
                        if (key === "items") {
                          return (
                            <div className="card p-0  " key={key}>
                              <div className="card-header">
                                <h3 className="card-title text-primary mt-3 mb-0">
                                  Items
                                </h3>
                              </div>
                              <div className="input-block mb-3">
                                {value.map((item, idx) => (
                                  <div
                                    key={idx}
                                    className="row card-body justify-content-start"
                                  >
                                    {Object.entries(item).map(
                                      ([itemKey, itemVal]) => (
                                        <div key={itemKey} className="col-md-6">
                                          <div className="input-block mb-3 key={payKey}">
                                            <label className="form-label">
                                              {itemKey
                                                .replace(/_/g, " ")
                                                .replace(/\b\w/g, (l) =>
                                                  l.toUpperCase()
                                                )}
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={itemVal}
                                              readOnly
                                            />
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </div>
                                ))}
                              </div>
                            </div>
                          );
                        }

                        if (key === "payment_details") {
                          return (
                            <div className="card p-0" key={key}>
                              <div className="card-header">
                                <h3 className="card-title text-primary mt-3  mb-0">
                                  Payment Details
                                </h3>
                              </div>

                              {value.map((payment, idx) => (
                                <div key={idx} className="row card-body ">
                                  {Object.entries(payment).map(
                                    ([payKey, payVal]) => (
                                      <div className="col-md-6" key={payKey}>
                                        <div className="input-block mb-3 key={payKey}">
                                          <label className="form-label">
                                            {payKey
                                              .replace(/_/g, " ")
                                              .replace(/\b\w/g, (l) =>
                                                l.toUpperCase()
                                              )}
                                          </label>
                                          {payKey === "payment_type" ? (
                                            <Select
                                              value={{
                                                label: payVal,
                                                value: payVal,
                                              }}
                                              onChange={(selected) => {
                                                const newPayments = [
                                                  ...formData
                                                    .invoice_receipt_details
                                                    .payment_details,
                                                ];
                                                newPayments[idx][payKey] =
                                                  selected.value;
                                                setFormData((prev) => ({
                                                  ...prev,
                                                  invoice_receipt_details: {
                                                    ...prev.invoice_receipt_details,
                                                    payment_details:
                                                      newPayments,
                                                  },
                                                }));
                                              }}
                                              options={paymentTypeOptions}
                                              styles={styles}
                                            />
                                          ) : (
                                            <input
                                              className="form-control"
                                              type="text"
                                              value={payVal}
                                              readOnly
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              ))}
                            </div>
                          );
                        }

                        return (
                          <div className="col-md-6" key={key}>
                            <div className="input-block mb-3">
                              <label className="col-form-label">
                                {key
                                  .replace(/_/g, " ")
                                  .replace(/\b\w/g, (l) => l.toUpperCase())}
                              </label>
                              {key === "document_type" ? (
                                <Select
                                  value={{ label: value, value }}
                                  onChange={(selected) =>
                                    handleSelectChange(
                                      key,
                                      selected,
                                      "invoice_receipt_details"
                                    )
                                  }
                                  options={docTypeOptions}
                                  styles={styles}
                                />
                              ) : key === "vat_percentage" ? (
                                <Select
                                  value={{ label: value, value }}
                                  onChange={(selected) =>
                                    handleSelectChange(
                                      key,
                                      selected,
                                      "invoice_receipt_details"
                                    )
                                  }
                                  options={vatOptions}
                                  styles={styles}
                                />
                              ) : (
                                <input
                                  className="form-control"
                                  type="text"
                                  value={value}
                                  readOnly
                                />
                              )}
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>

                <div className="submit-section">
                  <button className="btn btn-primary submit-btn">تعديل</button>
                </div>
              </form>
            </div>

            {/* <div className="modal-body">
              <form className="border-div primary rounded-1">
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Job Title</label>
                      <input className="form-control" type="text" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Department</label>
                      <Select
                        placeholder="Select"
                        onChange={setSelectedOption}
                        options={options}
                        styles={customStyles}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Job Location</label>
                      <input className="form-control" type="text" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">No of Vacancies</label>
                      <input className="form-control" type="text" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Experience</label>
                      <input className="form-control" type="text" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Age</label>
                      <input className="form-control" type="text" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Salary From</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Salary To</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Job Type</label>
                      <Select
                        placeholder="Select"
                        onChange={setSelectedOptionTwo}
                        options={optionsTwo}
                        styles={customStyles}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Status</label>
                      <Select
                        placeholder="Select Designation"
                        onChange={setSelectedOptionThree}
                        options={optionsThree}
                        styles={customStyles}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Start Date</label>
                      <DatePicker
                        className="form-control floating datetimepicker"
                        selected={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Expired Date</label>
                      <DatePicker
                        className="form-control floating datetimepicker "
                        selected={selectedDateTwo}
                        onChange={handleDateChangeTwo}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Description</label>
                      <textarea className="form-control" defaultValue={""} />
                    </div>
                  </div>
                </div>
                <div className="submit-section">
                  <button className="btn btn-primary submit-btn">تعديل</button>
                </div>
              </form>
            </div> */}
          </div>
        </div>
      </div>
      <NotFreeModal
        modalId="notFreeModal"
        title="اظهار المستند "
        content="اظهار المستند غير متاح  في النسخة المجانية  ! "
      />
    </>
  );
};

export default EditInvoiceModal;
